import { render, staticRenderFns } from "./CallForwardSettingModal.vue?vue&type=template&id=eab68858&"
import script from "./CallForwardSettingModal.vue?vue&type=script&lang=js&"
export * from "./CallForwardSettingModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports